import React from 'react';

import classNames from 'classnames';

import { Input } from '@buildoutinc/blueprint-react/ui/Input';
import { Label } from '@buildoutinc/blueprint-react/ui/Label';
import { OTHER } from './selection';
import { RadioGroup } from '@buildoutinc/blueprint-react/ui/RadioGroup';

import type { QuestionOption } from './types';
import type { Selection } from './selection';

const PANEL_CLASS = 'ai-assistant-question-option d-flex flex-column gap-1 border rounded p-3 mb-0';
const IDLE_CLASS = 'bg-gradient-ai-card-hover border-hover-purple-heart-300';
const SELECTED_CLASS = 'bg-gradient-ai-card border-primary';

const panelClass = (selected: boolean) => classNames(PANEL_CLASS, selected ? SELECTED_CLASS : IDLE_CLASS);

interface Props {
  disabled: boolean;
  options: QuestionOption[];
  other: string;
  selection: Selection;
  onChoose: (value: Selection) => void;
  onEnter: () => void;
  onOtherChange: (text: string) => void;
}

export function QuestionOptions({ disabled, options, other, selection, onChoose, onEnter, onOtherChange }: Props) {
  return (
    <RadioGroup
      className="d-flex flex-column gap-2"
      value={selection}
      onValueChange={value => onChoose(value as Selection)}
    >
      {options.map((option, index) => (
        <Label
          className={panelClass(selection === String(index))}
          key={option.label}
          onClick={() => onChoose(String(index))}
        >
          <RadioGroup.Item className="visually-hidden" disabled={disabled} value={String(index)} />
          <span className="fw-semibold">{option.label}</span>
          {option.description && <span className="text-muted">{option.description}</span>}
        </Label>
      ))}

      <Label
        className={panelClass(selection === OTHER)}
        onClick={() => onChoose(OTHER)}
      >
        <RadioGroup.Item className="visually-hidden" disabled={disabled} value={OTHER} />
        <span className="fw-semibold">Other</span>
        <Input
          disabled={disabled}
          placeholder="Type your own answer here"
          value={other}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => onOtherChange(event.target.value)}
          onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              onEnter();
            }
          }}
        />
      </Label>
    </RadioGroup>
  );
}
